<template>
<!-- NOTE (TEMPLATE) error page 404 "not found" -->


  <div class="app flex-row align-items-center Back ">
    <!-- NOTE (TEMPLATE) error page 404 "not found" -->

    <div class="container">
      <b-row class="justify-content-center ">
        <div class="col">
          <div style=" height: 20vh"></div>
          <div>
            <b-jumbotron>
              <template v-slot:header
                ><span class="text-secondary display-1">404</span></template>

              <template v-slot:lead>
                <h1 class="text-info">متاسفانه صفحه یافت نشد!</h1>
              </template>

              <hr />

              <b-button variant="success" href="/">رفتن به خانه</b-button>
            </b-jumbotron>
          </div>
        </div>
        <!-- <p style="font-size:100px" class="text-primary">404 </p> -->

        <div class="col">
          <img src="../assets/images/404.gif" class="container-fluid" />
        </div>

        <!-- 
        <b-col >
           <div class="clearfix">
            <h1 class="float-left display-3 mr-4">
            404
            </h1>
            <h4 class="pt-3">برگه یافت نشد</h4>
         
            <a href="/">
              <p class="text-muted">بازگشت به خانه</p>
            </a>
          </div>
            
        </b-col>
        <b-col class="6">
          
        </b-col>
       -->
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Page404"
};
</script>
<style>
.Back {
  background-color: #ffffff;
  /* background-image: url("../assets/images/resBack.png");

  background-size: cover; */
}
.jumbotron {
  background-color: #ffffff;
}
/* .responsive {
  width: 100%;
  max-width: 800px;
  height: auto;
} */
</style>
